import { setRegionDetailsData } from '../../redux/regionDetailsDataSlice';
import { setMetierDetailsData } from '../../redux/metierDetailsDataSlice';
import { setMarqueDetailsData } from '../../redux/marqueDetailsDataSlice';
import { setPoleDetailsData } from '../../redux/poleDetailsDataSlice';
import { setCompanyDetailsData } from '../../redux/companyDetailsDataSlice';
import { setSiteDetailsData } from '../../redux/siteDetailsDataSlice';
import { setUserDetailsData } from '../../redux/userDetailsDataSlice';
import { setRisqueDetailsData } from '../../redux/risqueDetailsDataSlice';
import { setEquipmentDetailsData } from '../../redux/equipmentDetailsDataSlice';
import { setMachineDetailsData } from '../../redux/machineDetailsDataSlice';
import { setArticleFolderDetailsData } from '../../redux/articleFolderDetailsDataSlice';
import { resolveEntityPhotoUrl } from '../../utils/imageProxy';
import machineDefaultImage from '../../images/machineImageEmpty.svg';

/** Phase 3.1 — org; 3.2 — user/risk/equipment; 3.3 — machine; 3.4 — article folder cover. */
export const ENTITY_IMAGE_CONFIG = {
  region: {
    imageField: 'region_image',
    documentField: 'region_document',
    route: 'region-image',
    parentIdBodyKey: 'regionId',
    permission: 'region_update',
    setDetailsData: setRegionDetailsData,
    detailsSelector: (state) => state.RegionDetailsData,
    editorSubtitle: 'Ajouter une image de la région',
    deleteTitle: "Êtes-vous sûr de vouloir supprimer l'image de région ?",
    alt: 'Image de la région',
  },
  metier: {
    imageField: 'metier_image',
    documentField: 'metier_document',
    route: 'metier-image',
    parentIdBodyKey: 'metierId',
    permission: 'metier_update',
    setDetailsData: setMetierDetailsData,
    detailsSelector: (state) => state.MetierDetailsData,
    editorSubtitle: 'Ajouter une image du métier',
    deleteTitle: "Êtes-vous sûr de vouloir supprimer l'image de métier ?",
    alt: 'Image du métier',
  },
  marque: {
    imageField: 'marque_image',
    documentField: 'marque_document',
    route: 'marque-image',
    parentIdBodyKey: 'marqueId',
    permission: 'marques_update',
    setDetailsData: setMarqueDetailsData,
    detailsSelector: (state) => state.MarqueDetailsData,
    editorSubtitle: 'Ajouter une image de la marque',
    deleteTitle: "Êtes-vous sûr de vouloir supprimer l'image de marque ?",
    alt: 'Image de la marque',
  },
  pole: {
    imageField: 'pole_image',
    documentField: 'pole_document',
    route: 'pole-image',
    parentIdBodyKey: 'poleId',
    permission: 'pole_update',
    setDetailsData: setPoleDetailsData,
    detailsSelector: (state) => state.PoleDetailsData,
    editorSubtitle: 'Ajouter une image du pôle',
    deleteTitle: "Êtes-vous sûr de vouloir supprimer l'image de pôle ?",
    alt: 'Image du pôle',
  },
  company: {
    imageField: 'company_image',
    documentField: 'company_document',
    route: 'company-image',
    parentIdBodyKey: 'companyId',
    permission: 'entreprise_update',
    setDetailsData: setCompanyDetailsData,
    detailsSelector: (state) => state.CompanyDetailsData,
    editorSubtitle: "Ajouter une image de l'entreprise",
    deleteTitle: "Êtes-vous sûr de vouloir supprimer l'image d'entreprise ?",
    alt: "Image de l'entreprise",
  },
  site: {
    imageField: 'site_image',
    documentField: 'site_document',
    route: 'site-image',
    parentIdBodyKey: 'siteId',
    permission: 'site_update',
    setDetailsData: setSiteDetailsData,
    detailsSelector: (state) => state.SiteDetailsData,
    editorSubtitle: 'Ajouter une image du site',
    deleteTitle: "Êtes-vous sûr de vouloir supprimer l'image de site ?",
    alt: 'Image du site',
  },
  user: {
    imageField: 'user_image',
    documentField: 'user_document',
    documentRoute: 'user-document',
    route: 'user-image',
    parentIdBodyKey: 'userId',
    permission: 'user_update',
    setDetailsData: setUserDetailsData,
    detailsSelector: (state) => state.UserDetailsData,
    editorSubtitle: "Ajouter une photo de l'utilisateur",
    deleteTitle: "Êtes-vous sûr de vouloir supprimer la photo de l'utilisateur ?",
    alt: "Photo de l'utilisateur",
  },
  risk: {
    imageField: 'risk_image',
    documentField: 'risk_document',
    documentRoute: 'risk-document',
    route: 'risk-image',
    parentIdBodyKey: 'riskId',
    permission: 'risk_update',
    setDetailsData: setRisqueDetailsData,
    detailsSelector: (state) => state.RisqueDetailsData,
    editorSubtitle: 'Ajouter une image du risque',
    deleteTitle: "Êtes-vous sûr de vouloir supprimer l'image de risque ?",
    alt: 'Image du risque',
  },
  equipment: {
    imageField: 'equipment_image',
    documentField: 'equipment_document',
    documentRoute: 'equipment-document',
    route: 'equipment-image',
    parentIdBodyKey: 'equipmentId',
    permission: 'equipment_update',
    setDetailsData: setEquipmentDetailsData,
    detailsSelector: (state) => state.EquipmentDetailsData,
    editorSubtitle: "Ajouter une image de l'équipement",
    deleteTitle: "Êtes-vous sûr de vouloir supprimer l'image d'équipement ?",
    alt: "Image de l'équipement",
  },
  articleFolder: {
    imageField: 'article_folder_image',
    documentField: 'article_folder_document',
    route: 'article-folder-image',
    parentIdBodyKey: 'articleFolderId',
    permission: 'dossier_update',
    setDetailsData: setArticleFolderDetailsData,
    detailsSelector: (state) => state.ArticleFolderDetailsData,
    editorSubtitle: 'Ajouter une image du dossier',
    deleteTitle: "Êtes-vous sûr de vouloir supprimer l'image du dossier ?",
    alt: 'Image du dossier',
  },
  /**
   * Gallery photos are their own entity (`article-photo`), so the editor is always driven in
   * `mode="local"` here: the caller posts to `article-photo` (create) or `article-photo/:id/image`
   * (re-crop). No redux slice, hence no `setDetailsData` / `detailsSelector`.
   */
  articlePhoto: {
    imageField: 'article_photo_image',
    route: 'article-photo',
    parentIdBodyKey: 'articleItemId',
    permission: 'article_update',
    editorSubtitle: 'Ajouter une photo à l’article',
    deleteTitle: 'Êtes-vous sûr de vouloir supprimer cette photo ?',
    alt: 'Photo de l’article',
  },
  machine: {
    imageField: 'machine_image',
    route: 'machine-image',
    parentIdBodyKey: 'machineId',
    permission: 'machine_update',
    setDetailsData: setMachineDetailsData,
    detailsSelector: (state) => state.MachineDetailsData,
    editorSubtitle: 'Ajouter une image de la machine',
    deleteTitle: "Êtes-vous sûr de vouloir supprimer l'image de la machine ?",
    alt: 'Image de la machine',
  },
};

export function getEntityImageConfig(entityType) {
  const config = ENTITY_IMAGE_CONFIG[entityType];
  if (!config) {
    throw new Error(`Unknown entity image type: ${entityType}`);
  }
  return config;
}

export function entityGridPhotoUrl(entity, entityType, { size = 'small', fallback = machineDefaultImage } = {}) {
  const cfg = getEntityImageConfig(entityType);
  const resolved = resolveEntityPhotoUrl(entity, {
    imageField: cfg.imageField,
    documentField: cfg.documentField,
    size,
    fallback: fallback || machineDefaultImage,
  });
  // Never return empty string — CardMedia with src="" shows a broken-image icon.
  return resolved || machineDefaultImage;
}
